const renderSwatch = () => {
  const swatchColors = [...document.querySelectorAll('.color-swatch-container label')]

  !!swatchColors && swatchColors.map(swatch => {
    const parentContainer = swatch.parentElement
    const clon = swatch.querySelector('.bg-hover').cloneNode(true)

    swatch.addEventListener('mouseover', () => {
      clon.classList.add('show-tooltip')
      parentContainer.append(clon);
    });

    swatch.addEventListener('mouseout', () => {
      clon.remove()
    });
})
}

window.addEventListener('DOMContentLoaded', () => {
  renderSwatch()
})